
// Create the namespace for file operations.
var File = function () { }

// Create an "Open" function which accepts an ID (nFileUID)
File.Open = function (id, name) {
    // Check if this is a template.
    $.ajax({
        type: 'post',
        dataType: 'json',
        async: false,
        url: '/File/IsTemplate/' + id,
        data: {
            __RequestVerificationToken: getWindowAntiForgeryTokenValue()
        },
        success: function (result) {
            // Check if this is a template.
            if (result.success) {
                // This is a template.
                app.openWindow({
                    title: ___('EDIT_ATTRIBUTES'),
                    url: '/ManualTemplate/EditByFile/' + id,
                    resizable: true
                });
            } else {

                // MTM-6929 - Had to put this Ajax call since try catch was not working for this window.open() statement
                $.ajax({
                    url: '/File/IFileNullCheck/' + id,
                    type: 'post',
                    dataType: 'json',
                    async: false,
                    success: function (result) {
                        if (result.success) {
                            Ext.Msg.alert(___("ATTENTION_TITLE"), ___("INDICATED_FILE_DOES_NOT_EXIST_MSG"));
                            return;
                        }
                        else {
                            window.open("/File/Open/" + id + "/?name=" + (name || ''), "_blank");
                        }
                    }
                });
                // MTM-6929 Ends
            }
        }
    });
};

// Create an "OpenAttribute" function which accepts an ID (nFileUID)
// nCallSheetUID is optional.
File.OpenAttribute = function (id, name) {
    window.open("/File/OpenAttribute/" + id + '/?name=' + (name || ''), "_blank");
};